export default {
  INSERT_INTO_ALL: "INSERT_INTO_ALL_INVOICES_REMINDERINVOICE",
  ADD_TO_IN_PROGRESS: "ADD_TO_IN_PROGRESS_INVOICES_REMINDERINVOICE",
  REMOVE_FROM_IN_PROGRESS: "REMOVE_FROM_IN_PROGRESS_INVOICES_REMINDERINVOICE",
  INSERT_INTO_FORMS: "INSERT_INTO_FORMS_INVOICES_REMINDERINVOICE",
  DESTROY_FORM: "DESTROY_FORM_INVOICES_REMINDERINVOICE",
  SET_FORM_ERROR: "SET_FORM_ERROR_INVOICES_REMINDERINVOICE",
  UPDATE_FORM_INSTANCE: "UPDATE_FORM_INSTANCE_INVOICES_REMINDERINVOICE",
  INSERT_INTO_PAGINATION: "INSERT_INTO_PAGINATION_INVOICES_REMINDERINVOICE",
  INSERT_INTO_FILTERED: "INSERT_INTO_FILTERED_INVOICES_REMINDERINVOICE",
  RESET_STATE: "RESET_STATE_INVOICES_REMINDERINVOICE",
  SET_ASK_DELETE_DATA: "SET_ASK_DELETE_DATA_INVOICES_REMINDERINVOICE",
  REMOVE_OBJECT: "REMOVE_OBJECT_INVOICES_REMINDERINVOICE",
  CLEAR_FETCHED: "CLEAR_FETCHED_INVOICES_REMINDERINVOICE",

  LIST_URL: "/accounting/invoices/reminderinvoice/list/",
  POST_URL: "/accounting/invoices/reminderinvoice/",
  PATCH_URL: "/accounting/invoices/reminderinvoice/",
  GET_URL: "/accounting/invoices/reminderinvoice/",

  STORE_NAME: "reminderInvoice",
};
